<template>
    <v-container>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="uploding" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span>処理中です...</span>
        </v-overlay>
        <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1">
                <v-btn x-large height="56" class="font-size-20" @click="prevPage">< 戻る</v-btn>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="text-center">
                <label-component fontSize="30" fontWeight="bold">書類のインポート</label-component>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <pdf-upload-component v-if="!uploaded" base-route="first" ref="pdfUploadComponent" :db-file-list="[]" :pdf-server-check=false @triggerEvent="changeFile"></pdf-upload-component>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-expansion-panels :value="0">
                    <v-expansion-panel v-if="uploaded">
                        <v-expansion-panel-header color="#F4FEFB">
                            <v-row>
                                <v-col col="12" xl="4">
                                   <label-component fontWeight="bold">処理完了</label-component>
                                </v-col>
                                <v-spacer/>
                                <v-col col="12" xl="4">
                                    <label-component v-if="errCnt <= 0" class="d-flex justify-center"color="green"><v-icon color="green">mdi-checkbox-marked-circle</v-icon>成功</label-component>
                                    <label-component v-else color="red" class="d-flex justify-center"><v-icon color="red">mdi-alert-circle</v-icon>失敗 {{ errCnt }} 件</label-component>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content v-for="(list, index) in lists" :key="index" color="#F4FEFB">
                                <v-container>
                                    <v-row>
                                        <v-col col="12" xl="4">
                                           <label-component>{{ list.file_name }}</label-component>
                                        </v-col>
                                        <v-spacer/>
                                        <v-col col="12" xl="4">
                                            <label-component :color="list.success ? 'green' : 'red'" class="d-flex justify-center">
                                                <v-icon v-if="list.success" color="green">mdi-checkbox-marked-circle</v-icon>
                                                <v-icon v-else color="red">mdi-alert-circle</v-icon>
                                                {{ list.file_message }}
                                            </label-component>
                                        </v-col>
                                    </v-row>
                                </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="text-center">
                <v-btn v-if="uploaded" color="red" class="white--text" @click="otherUpload">別の契約書を選択してインポート</v-btn>
                <v-btn v-else color="green" class="white--text" :disabled="isSelectedUploadFile" @click="upload">選択した契約書をインポート</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        data() {
          return {
            files: [],
            objectIds: [],
            message: {
                success: false,
                text: '',
            },
            uploding: false,
            uploaded: false,
            errCnt: 0,
            lists: [],
          }
        },
        props:['id'],
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isSelectedUploadFile: {
                get() {
                    if (this.files.length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                },
                set(value) {
                    
                }
            }
        },
        methods: {
            // 遷移元に戻る
            prevPage() {
                history.back();
            },
            // アップロード
            upload: async function() {
                this.uploding = true;
                let formData = new FormData();
                for(let i = 0; i < this.files.length; i++){
                    formData.append('files[]', this.files[i][0].file);
                }
                let config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };
                var self = this;
                try {
                    await window.axios
                        .post('upload-import-documents', formData, config)
                        .then(function (response) {
                            self.$refs.pdfUploadComponent.deleteAllFiles();
                            self.uploaded = true;
                            self.errCnt = response.data.err_count;
                            self.lists = response.data.upload_results;
                            
                            self.message.text = response.data.message;
                            self.message.success = true;
                        })
                        .catch(function (response) {
                            self.lists.splice(0);
                            self.$refs.pdfUploadComponent.deleteAllFiles();
                            self.uploaded = false;
                            
                            self.message.success = false;
                            self.message.text = "保存処理に失敗しました";
                        }
                    );
                } finally {
                    this.uploding = false;
                }
            },
            otherUpload: function() {
                this.lists.splice(0);
                this.uploaded = false;
            },
            changeFile: function(value) {
                this.files = value;
            },
        }
    }
</script>

<style scoped>
    .enter {
        background-color: #F2F2F2;
    }
    .drop_area {
        color: gray;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 500px;
        height: 500px;
        border: dashed 2px #ccc;
        border-radius: 50%;
        text-align: center;
    }
    .upload_icon {
        transform: scale(4, 4);
    }
</style>
